const VISATYPES = [
	{
		value: 'student',
		label: 'VISA นักเรียน',
	},
	{
		value: 'tourist',
		label: 'VISA ท่องเที่ยว',
	},
];

export default VISATYPES;
